import React from 'react';
import { FlaskConical } from 'lucide-react';

// The height the strip takes at the top of the screen; the app shell pads itself by the same
// amount so nothing hides underneath.
export const ENVIRONMENT_STRIP_CLASS = 'h-6';
export const ENVIRONMENT_STRIP_OFFSET = 'pt-6';
export const ENVIRONMENT_STRIP_TOP = 'top-6';

/**
 * A strip across the top of every QA screen, the sign-in page included. QA and the real system
 * look identical and sit on the same server; staff who bookmarked QA during testing must never
 * register a real patient there by mistake. Shown only when the server says it is QA.
 */
export default function EnvironmentStrip() {
  return (
    <div
      role="note"
      className={`fixed top-0 inset-x-0 z-[60] ${ENVIRONMENT_STRIP_CLASS} flex items-center justify-center gap-1.5 bg-amber-400 text-amber-950 text-xs font-semibold tracking-wide shadow-sm print:hidden`}
    >
      <FlaskConical className="w-3.5 h-3.5" aria-hidden="true" />
      QA test system. Not for real patient records.
    </div>
  );
}
